// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grey-box[data-v-1696cd7b]{background:#f4f4f7;padding:10px 5px 15px 20px;border-radius:10px}.grey-box-label[data-v-1696cd7b]{font-weight:600}.w-checkbox[data-v-1696cd7b]{width:100px}.w-checkbox--sm[data-v-1696cd7b]{width:80px}", ""]);
// Exports
module.exports = exports;
